const items = [
  {
    icon: "ri-building-2-line",
    label: "Federal Enterprise Experience",
  },
  {
    icon: "ri-calendar-check-line",
    label: "Long-Term Program Support",
  },
  {
    icon: "ri-server-line",
    label: "Infrastructure & Database Engineering",
  },
  {
    icon: "ri-team-line",
    label: "Specialized Technical Teams",
  },
];

export default function CredibilityStrip() {
  return (
    <section className="bg-white border-b border-background-200/80">
      <div className="container-page py-8 md:py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {items.map((item) => (
            <div key={item.label} className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-primary-600 text-lg`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 leading-snug">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}